module.exports = __webpack_public_path__ + "media/images/cover/pool-house-2-9f6698db1616f30c349bfc67be8e595c.jpeg";